import { BaseSpec } from '../base/base-Spec';

/**
 * @publicApi
 */
export class SpecService<S> extends BaseSpec {
  constructor(public service: S) {
    super();
  }
}
